import {UIDeviceController} from '../../shared/scripts/ui_html/UIDeviceController'
import {StorageWrapper} from '../../shared/scripts/StorageWrapper'
import {UIUtilsEjsVariables} from '../../shared/scripts/UIUtilsEjsVariables'

export enum UIMGameMode {
    LANDSCAPE = 0,
    PORTRAIT = 1
}

export class UIMGameOrientationController {
    static readonly deprecatePortraitLandscapeToggleFromTimestamp = 1746037800000 // 1st may 2025
    constructor() {
        this.setPortraitModeForNewPlayers()
        this.disableLandscapeModeForNewPlayers()
        StorageWrapper.clearDeprecationStorage()
    }

    // eslint-disable-next-line class-methods-use-this
    private disableLandscapeModeForNewPlayers() {
        const firstSessionTimestamp = StorageWrapper.getFirstSessionTimestamp()
        if(firstSessionTimestamp == null) return

        const isNewPlayer = firstSessionTimestamp > UIMGameOrientationController.deprecatePortraitLandscapeToggleFromTimestamp
        if(!isNewPlayer) return

        const isIPadPlayer = UIDeviceController.isUserOnTabletApp()
        if(isIPadPlayer) return

        StorageWrapper.setPortraitGamePlayEnabled(true)
        if(!UIUtilsEjsVariables.hideLandscapeForNewPlayers) return
        document.getElementById('m-menu-game-mode')?.remove()
    }

    // eslint-disable-next-line class-methods-use-this
    private setPortraitModeForNewPlayers() {
        const shouldResetOrientation = StorageWrapper.shouldResetGameOrientation()
        if(shouldResetOrientation == false) return
        StorageWrapper.setPortraitGamePlayEnabled(true)
        StorageWrapper.setFirstSessionTimestamp(Date.now())
    }
}
